import React, { lazy, useEffect } from "react";
import { Route, Routes, useParams } from "react-router-dom";
import lazyLoad from "./lazyLoad";
import RequireAuth from "./RequireAuth";
import UserProfile from "../Pages/Login/UserProfile";
import { getUserProfile } from "../store/actions/user";
import { getStorage, getUser, isEmpty } from "../utils/common";
import { useDispatch, useSelector } from "react-redux";
import HoldBalenceReports from "../Pages/Reports/HoldBalenceReports.js";
import Mcc from "../components/Role/Mcc/index.js";
import MainReports from "../Pages/Reports/mainReport.js";
import SettleMentReports from "../Pages/Reports/settlementRepost.js";
import TransactionReports from "../Pages/Reports/transactionReport.js";
import EmailReports from "../Pages/Reports/EmailReports.js";
import OrgSetteleMentReport from "../Pages/Reports/OrgSetteleMent.js";
import OrgTransactionReport from "../Pages/Reports/OrgTransactionReport.js";
import Distributor from "../components/ManageDistributor/Distributor.js";
import UpiReports from "../Pages/Reports/UpiReport.js";
import Welcome from "../Pages/Welcome/index.js";
import { getFlag } from "../v2/core/flags";
import { V2RouteWrapper, V2ToggleRoute, V2OnlyRoute, PublicV2ToggleRoute } from "./V2RouteWrappers.jsx";
import { PERMISSIONS } from "../utils/Permissions.js";
import PermissionManagement from "../Pages/AcessManagement/PermissionManagement/index.jsx";
import MerchantAuthWrapper from "./MerchantRoutesWrapper.jsx";
import MerchantDetailWrapper from "./MerchantDetailWrapper.jsx";
import RoleManagement from "../Pages/AcessManagement/RoleManagement/index.jsx";
import PermissionsPage from "../Pages/AcessManagement/RoleManagement/RoleComponents/RolePermissions.jsx";
import SocietyPartnerHub from "../Pages/SocietyPartnerHub/index.jsx";
import SocietyDashboard from "../Pages/SocietyPartnerHub/SocietyDashboard.jsx";
import BeneUserList from "../components/MerchantDetail/BeneUserList.js";
import BasicUserList from "../Pages/Merchants/BasicUseList.js";
import NcmcUserList from "../Pages/Merchants/NcmcUserList.js";
import FosUserList from "../Pages/Merchants/FosUserList.js";
import ProgramManager from "../components/ManageDistributor/ProgramManager.js";
import Create from "../Pages/SendBanner/create.js";
import AddMcc from "../components/ManageMCC/AddMCC.js";
import OrgHoldBalence from "../Pages/Reports/OrgHoldBalence.js";
import ViewMCCList from "../components/ManageMCC/ViewMCCList.js";
import CardProductManagement from "../Pages/CardProductManagement/CardManagement/index.jsx";
import OrgCardManagement from "../Pages/CardProductManagement/OrgCardManagement/index.jsx";
import TransactionCharges from "../Pages/TransactionCharges/index.js";
import TransactionChargesV2 from "../v2/pages/TransactionChargesV2/TransactionChargesV2.jsx";
import QRInventoryV2 from "../v2/pages/InventoryManagementV2/QRInventoryV2";
import SoundboxInventoryV2 from "../v2/pages/InventoryManagementV2/SoundboxInventoryV2/SoundboxInventoryV2";
import QRRequestV2 from "../v2/pages/InventoryManagementV2/QRRequestV2/QRRequestV2";
import TidWhitelistingV2 from "v2/pages/PartnerV2/TidWhitelistingV2";
import TidWhitelisting from "components/ManageDistributor/TidWhitelisting";
import CashbackConfig from "../components/Role/CashbackConfiguration";
import CashbackConfigV2 from "../v2/pages/PaymentSettingsV2/CashbackConfigV2";
import OfflineTransactionReport from "Pages/Reports/OfflineTransReport";
import OfflineReportV2 from "v2/pages/ManageReportsV2/OfflineReportV2";
import InventoryListV2 from "v2/pages/ManageCardV2/InventoryListV2";
import Form60V2 from "v2/pages/Form60V2/Form60v2";
import ViewMandateList from "v2/pages/ManageMandateV2/ViewMandateList";
import ViewMandateDetail from "v2/pages/ManageMandateV2/ViewMandateDetail";
import RevokeMandateList from "v2/pages/ManageMandateV2/RevokeMandate";
import ScheduleMaintenance from "v2/pages/ManageNotificationV2/ScheduleMaintenance";
const DashboardPage = lazyLoad(lazy(() => import("../Pages/Dashboard")));
const MerchantList = lazyLoad(lazy(() => import("../Pages/Merchants/List")));
const LoginPage = lazyLoad(lazy(() => import("../Pages/Login")));
const CPVUserList = lazyLoad(lazy(() => import("../Pages/Cpv/index")));
const AddAdmin = lazyLoad(lazy(() => import("../Pages/ManageAdmin/AddAdmin")));
const AdminList = lazyLoad(lazy(() => import("../Pages/ManageAdmin/AdminList")));
const BusinessIndividualList = lazyLoad(lazy(() => import("../Pages/Role/BusinessIndividualList")));
const BusinessIndividual = lazyLoad(lazy(() => import("../Pages/Role/BusinessIndividual")));
const PaymentSettings = lazyLoad(lazy(() => import("../components/MerchantDetail/PaymentSettings")));
const ManageCardList = lazyLoad(lazy(() => import("../Pages/ManageCard/ManageCardList")));
const ManageOrderList = lazyLoad(lazy(() => import("../Pages/ManageCard/ManageOrderList")));
const ManageBoxOrder = lazyLoad(lazy(() => import("../Pages/ManageSoundbox/ManageBoxOrder")));
const PhysicalCard = lazyLoad(lazy(() => import("../Pages/ManageCard/PhysicalCard")));
const VirtualCard = lazyLoad(lazy(() => import("../Pages/ManageCard/VirtualCard")));
const VirtualInventory = lazyLoad(lazy(() => import("../Pages/ManageCard/VirtualInventory")));
const PhysicalInventory = lazyLoad(lazy(() => import("../Pages/ManageCard/PhysicalInventory")));
const Transactions = lazyLoad(lazy(() => import("../Pages/Transactions")));
const Tickets = lazyLoad(lazy(() => import("../Pages/Tickets")));
const CreateTickets = lazyLoad(lazy(() => import("../Pages/Tickets/add")));
const Support = lazyLoad(lazy(() => import("../Pages/Support")));
const AddQuestionForm = lazyLoad(lazy(() => import("../Pages/Support/AddQuestionForm")));
const AddTopicForm = lazyLoad(lazy(() => import("../Pages/Support/AddTopicForm")));
const GenerateQR = lazyLoad(lazy(() => import("../Pages/QRCode/GenerateQR")));
const ManageNotificationHub = lazyLoad(lazy(() => import("../Pages/ManageNotificationHub")));
const NotificationList = lazyLoad(lazy(() => import("../Pages/NotificationList")));
const SendNotification = lazyLoad(lazy(() => import("../Pages/SendNotification")));
const SendBanner = lazyLoad(lazy(() => import("../Pages/SendBanner")));
const ManageBanners = lazyLoad(lazy(() => import("../Pages/ManageBanner")));
const CreateBanner = lazyLoad(lazy(() => import("../Pages/ManageBanner/add")));
const ManageLoginHistory = lazyLoad(lazy(() => import("../Pages/ManageLoginHistory")));
const ChangePassword = lazyLoad(lazy(() => import("../Pages/ChangePassword")));
const AddPaymentCollect = lazyLoad(lazy(() => import("../Pages/ReconcileCollect/AddPayment")));
const ReconcileCollect = lazyLoad(lazy(() => import("../Pages/ReconcileCollect")));
const ReconcileApprovalUserList = lazyLoad(lazy(() => import("../Pages/ReconcileCollect/ApprovalUserList")));
const ReconcileAddUserApproval = lazyLoad(lazy(() => import("../Pages/ReconcileCollect/AddUserApproval")));
const ReconcileEditUserApproval = lazyLoad(lazy(() => import("../Pages/ReconcileCollect/EditUserApproval")));
const Payback = lazyLoad(lazy(() => import("../Pages/Payback")));
const AddPayback = lazyLoad(lazy(() => import("../Pages/Payback/AddPayback")));
const PaybackRequestList = lazyLoad(lazy(() => import("../Pages/Payback/PaybackRequestList")));
const AddUserApproval = lazyLoad(lazy(() => import("../Pages/Payback/AddUserApproval")));
const EditUserApproval = lazyLoad(lazy(() => import("../Pages/Payback/EditUserApproval")));
const ApprovalUserList = lazyLoad(lazy(() => import("../Pages/Payback/ApprovalUserList")));
const RolePermission = lazyLoad(lazy(() => import("../Pages/RolePermission")));
const DistributorList = lazyLoad(lazy(() => import("../Pages/ManageDistributor/DistributorList")));
const AddDistributor = lazyLoad(lazy(() => import("../Pages/ManageDistributor/AddDistributor")));
const Reports = lazyLoad(lazy(() => import("../Pages/Reports")));
const ReportByTransaction = lazyLoad(lazy(() => import("../Pages/Reports/ReportByTransaction")));
const DailyReports = lazyLoad(lazy(() => import("../Pages/Reports/DailyReports")));
const EscrowTransactions = lazyLoad(lazy(() => import("../Pages/EscrowTransactions")));
const PageNotFound = lazyLoad(lazy(() => import("../Pages/PageNotFound")));
const QRCodeInventory = lazyLoad(lazy(() => import("../Pages/InventoryManagement/QRInventory")));
const SoundboxInventory = lazyLoad(lazy(() => import("../Pages/InventoryManagement/SoundboxInventory")));
const QRRequest = lazyLoad(lazy(() => import("../Pages/InventoryManagement/QRRequest")));

const SocietyPartnerDetailsGate = lazyLoad(lazy(() => import("../v2/pages/PartnerV2/SocietyPartnerDetailsGate.jsx")));
const WelcomeV2 = lazyLoad(lazy(() => import("../v2/pages/WelcomeV2")));
const OverviewV2 = lazyLoad(lazy(() => import("../v2/pages/OverviewV2")));
const AdminListV2 = lazyLoad(lazy(() => import("../v2/pages/ManageAdminV2/AdminListV2")));
const AddAdminV2 = lazyLoad(lazy(() => import("../v2/pages/ManageAdminV2/AddAdminV2")));
const ManagePermissionV2 = lazyLoad(lazy(() => import("../v2/pages/ManagePermissionV2/ManagePermissionV2")));
const UserListV2 = lazyLoad(lazy(() => import("../v2/pages/User/UserListV2")));
const AddDistributorV2 = lazyLoad(lazy(() => import("../v2/pages/ManageDistributorV2/AddDistributorV2")));
const DistributorListV2 = lazyLoad(lazy(() => import("../v2/pages/ManageDistributorV2/DistributorListV2")));
const SocietyPartnerV2 = lazyLoad(lazy(() => import("../v2/pages/PartnerV2/SocietyPartnerV2")));
const ProgramManagerV2 = lazyLoad(lazy(() => import("../v2/pages/PartnerV2/ProgramManagerV2")));
const AddMccV2 = lazyLoad(lazy(() => import("../v2/pages/ManageMccV2/AddMccV2")));
const ViewMccListV2 = lazyLoad(lazy(() => import("../v2/pages/ManageMccV2/ViewMccListV2")));
const AddNewV2 = lazyLoad(lazy(() => import("../v2/pages/PaymentSettingsV2/AddNewV2")));
const PaymentSettingsListV2 = lazyLoad(lazy(() => import("../v2/pages/PaymentSettingsV2/PaymentSettingsListV2")));
const PaymentSettingsDefaultV2 = lazyLoad(lazy(() => import("../v2/pages/PaymentSettingsV2/PaymentSettingsDefaultV2")));
const MccConfigV2 = lazyLoad(lazy(() => import("../v2/pages/PaymentSettingsV2/MccConfigV2")));
const AssignCardsV2 = lazyLoad(lazy(() => import("../v2/pages/ManageCardV2/AssignCardsV2")));
const OrderListV2 = lazyLoad(lazy(() => import("../v2/pages/ManageCardV2/OrderListV2")));
const PhysicalCardV2 = lazyLoad(lazy(() => import("../v2/pages/ManageCardV2/PhysicalCardV2")));
const VirtualCardV2 = lazyLoad(lazy(() => import("../v2/pages/ManageCardV2/VirtualCardV2")));
const PhysicalInventoryV2 = lazyLoad(lazy(() => import("../v2/pages/ManageCardV2/PhysicalInventoryV2")));
const VirtualInventoryV2 = lazyLoad(lazy(() => import("../v2/pages/ManageCardV2/VirtualInventoryV2")));
const ManageBoxOrderV2 = lazyLoad(lazy(() => import("../v2/pages/ManageSoundboxV2/ManageBoxOrderV2")));
const TransactionsV2 = lazyLoad(lazy(() => import("../v2/pages/TransactionsV2/TransactionsV2")));
const ReportsV2 = lazyLoad(lazy(() => import("../v2/pages/ManageReportsV2/ReportsV2")));
const ReportsByTransactionV2 = lazyLoad(lazy(() => import("../v2/pages/ManageReportsV2/ReportsByTransactionV2")));
const DailyReportsV2 = lazyLoad(lazy(() => import("../v2/pages/ManageReportsV2/DailyReportsV2")));
const HoldBalanceReportsV2 = lazyLoad(lazy(() => import("../v2/pages/ManageReportsV2/HoldBalanceReportsV2")));
const OrgHoldBalanceReportsV2 = lazyLoad(lazy(() => import("../v2/pages/ManageReportsV2/OrgHoldBalanceReportsV2")));
const MainReportV2 = lazyLoad(lazy(() => import("../v2/pages/ManageReportsV2/MainReportV2")));
const EmailReportsV2 = lazyLoad(lazy(() => import("../v2/pages/ManageReportsV2/EmailReportsV2")));
const OrgSettlementReportsV2 = lazyLoad(lazy(() => import("../v2/pages/ManageReportsV2/OrgSettlementReportsV2")));
const OrgTransactionReportsV2 = lazyLoad(lazy(() => import("../v2/pages/ManageReportsV2/OrgTransactionReportsV2")));
const UpiReportsV2 = lazyLoad(lazy(() => import("../v2/pages/ManageReportsV2/UpiReportsV2")));
const SettlementReportsV2 = lazyLoad(lazy(() => import("../v2/pages/ManageReportsV2/SettlementReportsV2")));
const TransactionReportsV2 = lazyLoad(lazy(() => import("../v2/pages/ManageReportsV2/TransactionReportsV2")));
const NotificationListV2 = lazyLoad(lazy(() => import("../v2/pages/ManageNotificationV2/NotificationListV2")));
const SendNotificationV2 = lazyLoad(lazy(() => import("../v2/pages/ManageNotificationV2/SendNotificationV2")));
const BannerListV2 = lazyLoad(lazy(() => import("../v2/pages/ManageNotificationV2/BannerListV2")));
const BannerFormV2 = lazyLoad(lazy(() => import("../v2/pages/ManageNotificationV2/BannerFormV2")));
const ManageNotificationHubV2 = lazyLoad(lazy(() => import("../v2/pages/ManageNotificationV2/ManageNotificationHubV2")));
const TicketListV2 = lazyLoad(lazy(() => import("../v2/pages/TicketManagementV2/TicketListV2")));
const AddTicketV2 = lazyLoad(lazy(() => import("../v2/pages/TicketManagementV2/AddTicketV2")));
const EditTicketV2 = lazyLoad(lazy(() => import("../v2/pages/TicketManagementV2/EditTicketV2")));
const SupportV2 = lazyLoad(lazy(() => import("../v2/pages/HelpSupportV2/SupportV2")));
const AddQuestionV2 = lazyLoad(lazy(() => import("../v2/pages/HelpSupportV2/AddQuestionV2")));
const AddTopicV2 = lazyLoad(lazy(() => import("../v2/pages/HelpSupportV2/AddTopicV2")));
const EditQuestionV2 = lazyLoad(lazy(() => import("../v2/pages/HelpSupportV2/EditQuestionV2")));
const OperatorListV2 = lazyLoad(lazy(() => import("../v2/pages/ManageOperatorV2/OperatorListV2")));
const EditOperatorV2 = lazyLoad(lazy(() => import("../v2/pages/ManageOperatorV2/EditOperatorV2")));
const ManageOperators = lazyLoad(lazy(() => import("../Pages/ManageOperators")));
const AddOperator = lazyLoad(lazy(() => import("../Pages/ManageOperators/add")));
const LoginHistoryV2 = lazyLoad(lazy(() => import("../v2/pages/LoginHistoryV2/LoginHistoryV2")));
const ChangePasswordV2 = lazyLoad(lazy(() => import("../v2/pages/ChangePasswordV2/ChangePasswordV2")));
const RequestListV2 = lazyLoad(lazy(() => import("../v2/pages/ReconcileCollectV2/RequestListV2")));
const AddPaymentV2 = lazyLoad(lazy(() => import("../v2/pages/ReconcileCollectV2/AddPaymentV2")));
const ReconcileApprovalUserListV2 = lazyLoad(lazy(() => import("../v2/pages/ReconcileCollectV2/ApprovalUserListV2")));
const ReconcileAddApprovalUserV2 = lazyLoad(lazy(() => import("../v2/pages/ReconcileCollectV2/AddApprovalUserV2")));
const ReconcileEditApprovalUserV2 = lazyLoad(lazy(() => import("../v2/pages/ReconcileCollectV2/EditApprovalUserV2")));
const PaybackV2 = lazyLoad(lazy(() => import("../v2/pages/ManagePaybackV2/PaybackV2")));
const AddPaybackV2 = lazyLoad(lazy(() => import("../v2/pages/ManagePaybackV2/AddPaybackV2")));
const PaybackApprovalUserListV2 = lazyLoad(lazy(() => import("../v2/pages/ManagePaybackV2/PaybackApprovalUserListV2")));
const PaybackRequestListV2 = lazyLoad(lazy(() => import("../v2/pages/ManagePaybackV2/PaybackRequestListV2")));
const PaybackAddApprovalUserV2 = lazyLoad(lazy(() => import("../v2/pages/ManagePaybackV2/AddApprovalUserV2")));
const PaybackEditApprovalUserV2 = lazyLoad(lazy(() => import("../v2/pages/ManagePaybackV2/EditApprovalUserV2")));
const PermissionManagementV2 = lazyLoad(lazy(() => import("../v2/pages/AccessManagementV2/PermissionManagementV2")));
const RoleManagementV2 = lazyLoad(lazy(() => import("../v2/pages/AccessManagementV2/RoleManagementV2")));
const RolePermissionsV2 = lazyLoad(lazy(() => import("../v2/pages/AccessManagementV2/RolePermissionsV2")));
const SocietyPartnerHubV2 = lazyLoad(lazy(() => import("../v2/pages/OrganizationHubV2/SocietyPartnerHubV2")));
const SocietyDashboardV2 = lazyLoad(lazy(() => import("../v2/pages/OrganizationHubV2/SocietyDashboardV2")));
const CpvListingV2 = lazyLoad(lazy(() => import("../v2/pages/CpvListingV2/CpvListingV2")));
const CardProductManagementV2 = lazyLoad(lazy(() => import("../v2/pages/CardManagementV2/CardProductManagementV2")));
const OrgCardManagementV2 = lazyLoad(lazy(() => import("../v2/pages/CardManagementV2/OrgCardManagementV2")));
const LoginPageV2 = lazyLoad(lazy(() => import("../v2/pages/LoginPageV2")));
const UserProfileV2 = lazyLoad(lazy(() => import("../v2/pages/UserProfileV2")));
const BeneUserListV2 = lazyLoad(lazy(() => import("../v2/pages/BeneUserListV2")));
const GenerateQRV2 = lazyLoad(lazy(() => import("../v2/pages/GenerateQRV2")));
const ManageBannerIndexV2 = lazyLoad(lazy(() => import("../v2/pages/ManageBannerIndexV2")));
const ManageBannerFormV2 = lazyLoad(lazy(() => import("../v2/pages/ManageBannerFormV2")));

function RouteComponent() {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);

  // useEffect(() => {
  //   if(isEmpty(user))
  //   {
  //    dispatch(getUserProfile());
  //   }
  //  }, []);

  return (
    <Routes>
      <Route
        path="/"
        element={<PublicV2ToggleRoute flag="USE_V2_LOGIN" V2Component={LoginPageV2} V1Component={LoginPage} />}
      />
      <Route
        path="/login"
        element={<PublicV2ToggleRoute flag="USE_V2_LOGIN" V2Component={LoginPageV2} V1Component={LoginPage} />}
      />

      {getStorage("loggedin") && (
        <>
          <Route
            path="/welcome"
            element={
              <V2ToggleRoute flag="USE_V2_WELCOME" V2Component={WelcomeV2} V1Component={Welcome} />
            }
          />
          <Route
            path="/dashboard"
            element={
              <V2ToggleRoute flag="USE_V2_OVERVIEW" requiredPermission={PERMISSIONS.OVERVIEW} V2Component={OverviewV2} V1Component={DashboardPage} />
            }
          />
          <Route
            path="/profile"
            element={
              <V2RouteWrapper flag="USE_V2_PROFILE" V2Component={UserProfileV2} V1Component={UserProfile} />
            }
          />
          <Route path="/merchant/:usertype/list" element={<MerchantAuthWrapper />} />
          <Route path="merchant-detail/:id/:userType" element={<MerchantDetailWrapper />} />
          <Route
            path="/user-list/:accountNumber/:ifscCode"
            element={
              <V2RouteWrapper
                flag="USE_V2_BENE_USER_LIST"
                requiredPermission={PERMISSIONS.OVERVIEW}
                V2Component={BeneUserListV2}
                V1Component={BeneUserList}
              />
            }
          />
          <Route
            path="merchant/basic_user/list"
            element={
              <V2ToggleRoute
                flag="USE_V2_USER"
                requiredPermission={PERMISSIONS.MERCHANT_MIN_KYC_USER}
                V2Component={UserListV2}
                v2ComponentProps={{ mode: "basic_user" }}
                V1Component={BasicUserList}
              />
            }
          />
          <Route
            path="merchant/ncmc_user/list"
            element={
              <V2ToggleRoute
                flag="USE_V2_USER"
                requiredPermission={PERMISSIONS.MERCHANT_NCMC_USER}
                V2Component={UserListV2}
                v2ComponentProps={{ mode: "ncmc_user" }}
                V1Component={NcmcUserList}
              />
            }
          />
          <Route
            path="merchant/fos_user/list"
            element={
              <V2ToggleRoute
                flag="USE_V2_USER"
                requiredPermission={PERMISSIONS.MERCHANT_FOS_USER}
                V2Component={UserListV2}
                v2ComponentProps={{ mode: "fos_user" }}
                V1Component={FosUserList}
              />
            }
          />
          <Route
            path="/admin-register"
            element={
              <V2ToggleRoute flag="USE_V2_MANAGE_ADMIN" requiredPermission={PERMISSIONS.ADMIN_ADD} V2Component={AddAdminV2} V1Component={AddAdmin} />
            }
          />
          <Route
            path="/admin-edit/:id"
            element={
              <V2ToggleRoute flag="USE_V2_MANAGE_ADMIN" requiredPermission={PERMISSIONS.ADMIN_VIEW} V2Component={AddAdminV2} V1Component={AddAdmin} />
            }
          />
          <Route
            path="/admin-list"
            element={
              <V2ToggleRoute flag="USE_V2_MANAGE_ADMIN" requiredPermission={PERMISSIONS.ADMIN_VIEW} V2Component={AdminListV2} V1Component={AdminList} />
            }
          />
          <Route
            path="/payment-settings/mcc"
            element={
              <V2RouteWrapper
                flag="USE_V2_PAYMENT_SETTINGS"
                V2Component={MccConfigV2}
                V1Component={Mcc}
                requiredPermission={PERMISSIONS.PAYMENT_SETTING_MCC_CONFIGURATION}
              />
            }
          />
            <Route
            path="/payment-settings/cashback"
            element={
              <V2RouteWrapper
                flag="USE_V2_CASHBACK_CONFIG"
                V2Component={CashbackConfigV2}
                V1Component={CashbackConfig}
                requiredPermission={PERMISSIONS.PAYMENT_SETTING_CASHBACK_CONFIGURATION}
              />
            }
          />
          <Route
            path="/payment-settings/add"
            element={
              <V2RouteWrapper
                flag="USE_V2_PAYMENT_SETTINGS"
                V2Component={AddNewV2}
                V1Component={BusinessIndividual}
                requiredPermission={PERMISSIONS.PAYMENT_SETTING_ADD_NEW}
              />
            }
          />
          <Route
            path="/payment-settings/edit/:id"
            element={
              <V2RouteWrapper
                flag="USE_V2_PAYMENT_SETTINGS"
                V2Component={AddNewV2}
                V1Component={BusinessIndividual}
                requiredPermission={PERMISSIONS.PAYMENT_SETTING_LIST}
              />
            }
          />
          <Route
            path="/payment-settings/list"
            element={
              <V2RouteWrapper
                flag="USE_V2_PAYMENT_SETTINGS"
                V2Component={PaymentSettingsListV2}
                V1Component={BusinessIndividualList}
                requiredPermission={PERMISSIONS.PAYMENT_SETTING_LIST}
              />
            }
          />
          <Route
            path="/payment-settings/default"
            element={
              <V2RouteWrapper
                flag="USE_V2_PAYMENT_SETTINGS"
                V2Component={PaymentSettingsDefaultV2}
                V1Component={PaymentSettings}
                requiredPermission={PERMISSIONS.PAYMENT_SETTING_DEFAULT}
              />
            }
          />
          <Route
            path="/manage-card/list"
            element={
              <V2RouteWrapper
                flag="USE_V2_MANAGE_CARD"
                V2Component={AssignCardsV2}
                V1Component={ManageCardList}
                requiredPermission={PERMISSIONS.MANAGE_CARD_ASSIGN_CARD}
              />
            }
          />
          <Route
            path="/manage-card/orders"
            element={
              <V2RouteWrapper
                flag="USE_V2_MANAGE_CARD"
                V2Component={OrderListV2}
                V1Component={ManageOrderList}
                requiredPermission={PERMISSIONS.MANAGE_CARD_ORDER_LIST}
              />
            }
          />
           <Route
            path="/manage-card/inventory-listing"
            element={
              <V2RouteWrapper
                flag="USE_V2_MANAGE_CARD"
                V2Component={InventoryListV2}
                // V1Component={ManageOrderList}
                requiredPermission={PERMISSIONS.INVENTORY_FILE_LIST}
              />
            }
          />
          <Route
            path="/manage-soundbox/orders"
            element={
              <V2RouteWrapper
                flag="USE_V2_MANAGE_SOUNDBOX"
                V2Component={ManageBoxOrderV2}
                V1Component={ManageBoxOrder}
                requiredPermission={PERMISSIONS.MANAGE_SOUNDBOX_ORDER}
              />
            }
          />
          <Route
            path="/manage-card/physical-card"
            element={
              <V2RouteWrapper
                flag="USE_V2_MANAGE_CARD"
                V2Component={PhysicalCardV2}
                V1Component={PhysicalCard}
                requiredPermission={PERMISSIONS.MANAGE_CARD_PHYSICAL_CARD}
              />
            }
          />
          <Route
            path="/manage-card/virtual-card"
            element={
              <V2RouteWrapper
                flag="USE_V2_MANAGE_CARD"
                V2Component={VirtualCardV2}
                V1Component={VirtualCard}
                requiredPermission={PERMISSIONS.MANAGE_CARD_VIRTUAL_CARD}
              />
            }
          />
          <Route
            path="/manage-card/physical-inventory"
            element={
              <V2RouteWrapper
                flag="USE_V2_MANAGE_CARD"
                V2Component={PhysicalInventoryV2}
                V1Component={PhysicalInventory}
                requiredPermission={PERMISSIONS.MANAGE_CARD_PHYSICAL_CARD}
              />
            }
          />
          <Route
            path="/manage-card/virtual-inventory"
            element={
              <V2RouteWrapper
                flag="USE_V2_MANAGE_CARD"
                V2Component={VirtualInventoryV2}
                V1Component={VirtualInventory}
                requiredPermission={PERMISSIONS.MANAGE_CARD_VIRTUAL_CARD}
              />
            }
          />
          <Route
            path="/transactions"
            element={
              <V2RouteWrapper
                flag="USE_V2_TRANSACTIONS"
                V2Component={TransactionsV2}
                V1Component={Transactions}
                requiredPermission={PERMISSIONS.TRANSACTION_PAYMENT || PERMISSIONS.TRANSACTION_SETTLEMENT}
              />
            }
          />
          <Route
            path="/transaction-charges"
            element={
              <V2RouteWrapper
                flag="USE_V2_TRANSACTIONS"
                V2Component={TransactionChargesV2}
                V1Component={TransactionCharges}
                requiredPermission={PERMISSIONS.TRANSACTION_CHARGES}
              />
            }
          />
          <Route
            path="/manage-tickets"
            element={
              <V2RouteWrapper
                flag="USE_V2_TICKET_MANAGEMENT"
                V2Component={TicketListV2}
                V1Component={Tickets}
                requiredPermission={PERMISSIONS.TICKET_MANAGEMENT}
              />
            }
          />
          <Route
            path="/ticket/add"
            element={
              <V2RouteWrapper
                flag="USE_V2_TICKET_MANAGEMENT"
                V2Component={AddTicketV2}
                V1Component={CreateTickets}
                requiredPermission={PERMISSIONS.TICKET_MANAGEMENT}
              />
            }
          />
          <Route
            path="/ticket/edit/:ticketId"
            element={
              <V2RouteWrapper
                flag="USE_V2_TICKET_MANAGEMENT"
                V2Component={EditTicketV2}
                V1Component={CreateTickets}
                requiredPermission={PERMISSIONS.TICKET_MANAGEMENT}
              />
            }
          />
          <Route
            path="/support"
            element={
              <V2RouteWrapper
                flag="USE_V2_HELP_SUPPORT"
                V2Component={SupportV2}
                V1Component={Support}
                requiredPermission={PERMISSIONS.HELP_SUPPORT}
              />
            }
          />
          <Route
            path="/email_reports"
            element={
              <V2RouteWrapper
                flag="USE_V2_MANAGE_REPORTS"
                V2Component={EmailReportsV2}
                V1Component={EmailReports}
                requiredPermission={PERMISSIONS.MANAGE_APPROVE_EMAIL_REPORTS}
              />
            }
          />
          <Route
            path="/support/faq/add-question"
            element={
              <V2RouteWrapper
                flag="USE_V2_HELP_SUPPORT"
                V2Component={AddQuestionV2}
                V1Component={AddQuestionForm}
                requiredPermission={PERMISSIONS.HELP_SUPPORT}
              />
            }
          />
          <Route
            path="/support/faq/add-topic"
            element={
              <V2RouteWrapper
                flag="USE_V2_HELP_SUPPORT"
                V2Component={AddTopicV2}
                V1Component={AddTopicForm}
                requiredPermission={PERMISSIONS.HELP_SUPPORT}
              />
            }
          />
          <Route
            path="/support/edit-question/:questionId"
            element={
              <V2ToggleRoute flag="USE_V2_HELP_SUPPORT" requiredPermission={PERMISSIONS.HELP_SUPPORT} V2Component={EditQuestionV2} V1Component={AddQuestionForm} />
            }
          />
          <Route
            path="/qr-generate"
            element={
              <V2RouteWrapper flag="USE_V2_QR_GENERATE" V2Component={GenerateQRV2} V1Component={GenerateQR} />
            }
          />
          <Route
            path="/manage-notification"
            element={
              <V2RouteWrapper
                flag="USE_V2_MANAGE_NOTIFICATION"
                V2Component={ManageNotificationHubV2}
                V1Component={ManageNotificationHub}
                requiredAnyOf={[PERMISSIONS.LIST_NOTIFICATION, PERMISSIONS.SEND_NOTIFICATION]}
              />
            }
          />
          <Route
            path="/manage-operators"
            element={
              <V2RouteWrapper
                flag="USE_V2_MANAGE_OPERATOR"
                V2Component={OperatorListV2}
                V1Component={ManageOperators}
                requiredPermission={PERMISSIONS.MANAGE_OPERATOR}
              />
            }
          />
          <Route
            path="/edit-operator/:id"
            element={
              <V2RouteWrapper
                flag="USE_V2_MANAGE_OPERATOR"
                V2Component={EditOperatorV2}
                V1Component={AddOperator}
                requiredPermission={PERMISSIONS.MANAGE_OPERATOR}
              />
            }
          />
          <Route
            path="/list-notification"
            element={
              <V2RouteWrapper
                flag="USE_V2_MANAGE_NOTIFICATION"
                V2Component={NotificationListV2}
                V1Component={NotificationList}
                requiredPermission={PERMISSIONS.LIST_NOTIFICATION}
              />
            }
          />
          <Route
            path="/send-notification"
            element={
              <V2RouteWrapper
                flag="USE_V2_MANAGE_NOTIFICATION"
                V2Component={SendNotificationV2}
                V1Component={SendNotification}
                requiredPermission={PERMISSIONS.SEND_NOTIFICATION}
              />
            }
          />
          <Route
            path="/manage-banner"
            element={
              <V2RouteWrapper
                flag="USE_V2_MANAGE_BANNER_LEGACY"
                V2Component={ManageBannerIndexV2}
                V1Component={ManageBanners}
              />
            }
          />
          <Route
            path="/banner/add"
            element={
              <V2RouteWrapper
                flag="USE_V2_MANAGE_BANNER_LEGACY"
                V2Component={ManageBannerFormV2}
                V1Component={CreateBanner}
              />
            }
          />
          <Route
            path="/banner/edit/:bannerId"
            element={
              <V2RouteWrapper
                flag="USE_V2_MANAGE_BANNER_LEGACY"
                V2Component={ManageBannerFormV2}
                V1Component={CreateBanner}
              />
            }
          />
          <Route
            path="/banner/create"
            element={
              <V2RouteWrapper
                flag="USE_V2_MANAGE_NOTIFICATION"
                V2Component={BannerFormV2}
                V1Component={Create}
                requiredPermission={PERMISSIONS.SEND_NOTIFICATION}
              />
            }
          />
          <Route
            path="/login-history"
            element={
              <V2RouteWrapper
                flag="USE_V2_LOGIN_HISTORY"
                V2Component={LoginHistoryV2}
                V1Component={ManageLoginHistory}
                requiredPermission={PERMISSIONS.LOGIN_HISTORY}
              />
            }
          />
          <Route
            path="/change-password"
            element={
              <V2RouteWrapper
                flag="USE_V2_CHANGE_PASSWORD"
                V2Component={ChangePasswordV2}
                V1Component={ChangePassword}
                requiredPermission={PERMISSIONS.CHANGE_PASSWORD}
              />
            }
          />
          <Route
            path="/reconcile/request-list"
            element={
              <V2RouteWrapper
                flag="USE_V2_RECONCILE_COLLECT"
                V2Component={RequestListV2}
                V1Component={ReconcileCollect}
              />
            }
          />
          <Route
            path="/reconcile-collect/add"
            element={
              <V2RouteWrapper
                flag="USE_V2_RECONCILE_COLLECT"
                V2Component={AddPaymentV2}
                V1Component={AddPaymentCollect}
              />
            }
          />
          <Route
            path="/reconcile/approval-user-list"
            element={
              <V2RouteWrapper
                flag="USE_V2_RECONCILE_COLLECT"
                V2Component={ReconcileApprovalUserListV2}
                V1Component={ReconcileApprovalUserList}
              />
            }
          />
          <Route
            path="/reconcile/add-approval-user"
            element={
              <V2RouteWrapper
                flag="USE_V2_RECONCILE_COLLECT"
                V2Component={ReconcileAddApprovalUserV2}
                V1Component={ReconcileAddUserApproval}
              />
            }
          />
          <Route
            path="/reconcile/edit-approval-user/:id"
            element={
              <V2RouteWrapper
                flag="USE_V2_RECONCILE_COLLECT"
                V2Component={ReconcileEditApprovalUserV2}
                V1Component={ReconcileEditUserApproval}
              />
            }
          />

          <Route
            path="/payback"
            element={
              <V2RouteWrapper
                flag="USE_V2_MANAGE_PAYBACK"
                V2Component={PaybackV2}
                V1Component={Payback}
                requiredPermission={PERMISSIONS.MANAGE_PAYBACK}
              />
            }
          />
          <Route
            path="/add/payback"
            element={
              <V2ToggleRoute flag="USE_V2_MANAGE_PAYBACK" requiredPermission={PERMISSIONS.MANAGE_PAYBACK || PERMISSIONS.MANAGE_PAYBACK_REQUEST_LIST} V2Component={AddPaybackV2} V1Component={AddPayback} />
            }
          />
          <Route
            path="/payback/request-list"
            element={
              <V2RouteWrapper
                flag="USE_V2_MANAGE_PAYBACK"
                V2Component={PaybackRequestListV2}
                V1Component={PaybackRequestList}
                requiredPermission={PERMISSIONS.MANAGE_PAYBACK_REQUEST_LIST}
              />
            }
          />
          <Route
            path="/payback/add-approval-user"
            element={
              <V2RouteWrapper
                flag="USE_V2_MANAGE_PAYBACK"
                V2Component={PaybackAddApprovalUserV2}
                V1Component={AddUserApproval}
                requiredPermission={PERMISSIONS.MANAGE_PAYBACK_APPROVAL_USER_LIST}
              />
            }
          />
          <Route
            path="/payback/edit-approval-user/:id"
            element={
              <V2RouteWrapper
                flag="USE_V2_MANAGE_PAYBACK"
                V2Component={PaybackEditApprovalUserV2}
                V1Component={EditUserApproval}
                requiredPermission={PERMISSIONS.MANAGE_PAYBACK_APPROVAL_USER_LIST}
              />
            }
          />
          <Route
            path="/payback/approval-user-list"
            element={
              <V2RouteWrapper
                flag="USE_V2_MANAGE_PAYBACK"
                V2Component={PaybackApprovalUserListV2}
                V1Component={ApprovalUserList}
                requiredPermission={PERMISSIONS.MANAGE_PAYBACK_APPROVAL_USER_LIST}
              />
            }
          />
          <Route
            path="/manage-permission"
            element={
              <V2ToggleRoute flag="USE_V2_MANAGE_PERMISSION" requiredPermission={PERMISSIONS.MANAGE_PERMISSION} V2Component={ManagePermissionV2} V1Component={RolePermission} />
            }
          />
          <Route
            path="/distributor-list"
            element={
              <V2RouteWrapper
                flag="USE_V2_MANAGE_DISTRIBUTOR"
                V2Component={DistributorListV2}
                V1Component={DistributorList}
                requiredPermission={PERMISSIONS.MANAGE_DISTRIBUTOR_VIEW}
              />
            }
          />
          <Route
            path="/distributor-register"
            element={
              <V2RouteWrapper
                flag="USE_V2_MANAGE_DISTRIBUTOR"
                V2Component={AddDistributorV2}
                V1Component={AddDistributor}
                requiredPermission={PERMISSIONS.MANAGE_DISTRIBUTOR_ADD}
              />
            }
          />
          <Route
            path="/distributor-edit/:id"
            element={
              <V2ToggleRoute flag="USE_V2_MANAGE_DISTRIBUTOR" V2Component={AddDistributorV2} V1Component={AddDistributor} />
            }
          />
          <Route
            path="/reports"
            element={
              <V2RouteWrapper
                flag="USE_V2_MANAGE_REPORTS"
                V2Component={ReportsV2}
                V1Component={Reports}
                requiredPermission={PERMISSIONS.MANAGE_REPORT}
              />
            }
          />
          <Route
            path="/reports-by-transaction"
            element={
              <V2RouteWrapper
                flag="USE_V2_MANAGE_REPORTS"
                V2Component={ReportsByTransactionV2}
                V1Component={ReportByTransaction}
                requiredPermission={PERMISSIONS.MANAGE_REPORT_BY_TRANSACTIONS}
              />
            }
          />
          <Route
            path="/daily-reports"
            element={
              <V2RouteWrapper
                flag="USE_V2_MANAGE_REPORTS"
                V2Component={DailyReportsV2}
                V1Component={DailyReports}
                requiredPermission={PERMISSIONS.MANAGE_DAILY_REPORT}
              />
            }
          />
          <Route
            path="/hold_balance_reports"
            element={
              <V2RouteWrapper
                flag="USE_V2_MANAGE_REPORTS"
                V2Component={HoldBalanceReportsV2}
                V1Component={HoldBalenceReports}
                requiredPermission={PERMISSIONS.MANAGE_HOLD_BALANCE_REPORT}
              />
            }
          />
          <Route
            path="/org_hold_balance_reports"
            element={
              <V2RouteWrapper
                flag="USE_V2_MANAGE_REPORTS"
                V2Component={OrgHoldBalanceReportsV2}
                V1Component={OrgHoldBalence}
                requiredPermission={PERMISSIONS.MANAGE_HOLD_BALANCE_REPORT}
              />
            }
          />
          <Route
            path="/main_reports"
            element={
              <V2RouteWrapper
                flag="USE_V2_MANAGE_REPORTS"
                V2Component={MainReportV2}
                V1Component={MainReports}
                requiredPermission={PERMISSIONS.MANAGE_MAIN_REPORT}
              />
            }
          />
          <Route
            path="/org_settelement_reports"
            element={
              <V2RouteWrapper
                flag="USE_V2_MANAGE_REPORTS"
                V2Component={OrgSettlementReportsV2}
                V1Component={OrgSetteleMentReport}
                requiredPermission={PERMISSIONS.MANAGE_ORG_SETTLEMENT_REPORTS}
              />
            }
          />
          <Route
            path="/org_transaction_reports"
            element={
              <V2RouteWrapper
                flag="USE_V2_MANAGE_REPORTS"
                V2Component={OrgTransactionReportsV2}
                V1Component={OrgTransactionReport}
                requiredPermission={PERMISSIONS.MANAGE_ORG_TRANSACTION_REPORTS}
              />
            }
          />
          <Route
            path="/settlement_reports"
            element={
              <V2RouteWrapper
                flag="USE_V2_MANAGE_REPORTS"
                V2Component={SettlementReportsV2}
                V1Component={SettleMentReports}
              />
            }
          />
          <Route
            path="/transaction_reports"
            element={
              <V2RouteWrapper
                flag="USE_V2_MANAGE_REPORTS"
                V2Component={TransactionReportsV2}
                V1Component={TransactionReports}
              />
            }
          />
            <Route
            path="/offline_report"
            element={
              <V2RouteWrapper
                flag="USE_V2_MANAGE_REPORTS"
                V2Component={OfflineReportV2}
                V1Component={OfflineTransactionReport}
                requiredPermission={PERMISSIONS.MANAGE_HOLD_BALANCE_REPORT}
              />
            }
          />

          <Route
            path="/upi_reports"
            element={
              <V2RouteWrapper
                flag="USE_V2_MANAGE_REPORTS"
                V2Component={UpiReportsV2}
                V1Component={UpiReports}
                requiredPermission={PERMISSIONS.MANAGE_UPI_REPORTS}
              />
            }
          />
          <Route
            path="/society-partner"
            element={
              <V2RouteWrapper
                flag="USE_V2_PARTNER"
                V2Component={SocietyPartnerV2}
                V1Component={Distributor}
                requiredPermission={PERMISSIONS.PARTNER_SOCIETY_PARTNER}
              />
            }
          />
          <Route
            path="/form-60"
            element={
              <V2RouteWrapper
                flag="USE_V2_FORM_60"
                V2Component={Form60V2}
                V1Component={Distributor}
                requiredPermission={PERMISSIONS.PARTNER_SOCIETY_PARTNER}
              />
            }
          />
          <Route
            path="/program-manager"
            element={
              <V2RouteWrapper
                flag="USE_V2_PARTNER"
                V2Component={ProgramManagerV2}
                V1Component={ProgramManager}
                requiredPermission={PERMISSIONS.PARTNER_SOCIETY_PARTNER}
              />
            }
          />
          <Route
            path="/tid-whitelisting"
            element={
              <V2RouteWrapper
                flag="USE_V2_TID_WHITELISTING"
                V2Component={TidWhitelistingV2}
                V1Component={TidWhitelisting}
                requiredPermission={PERMISSIONS.TID_WHITELISTING}
              />
            }
          />
          <Route
            path="/new-mcc"
            element={
              <V2RouteWrapper
                flag="USE_V2_MANAGE_MCC"
                V2Component={AddMccV2}
                V1Component={AddMcc}
                requiredPermission={PERMISSIONS.MERCHANT_BUSINESS_MERCHANT}
              />
            }
          />
          <Route
            path="/view-mcc-list"
            element={
              <V2RouteWrapper
                flag="USE_V2_MANAGE_MCC"
                V2Component={ViewMccListV2}
                V1Component={ViewMCCList}
                requiredPermission={PERMISSIONS.MERCHANT_BUSINESS_MERCHANT}
              />
            }
          />
          <Route
            path="/view-autopay-list"
            element={
              <V2RouteWrapper
                flag="USE_V2_MANAGE_AUTOPAY"
                V2Component={ViewMandateList}
                V1Component={ViewMandateList}
                requiredPermission={PERMISSIONS.MANAGE_AUTOPAY}
              />
            }
          />
          <Route
            path="/loan-repayment-autopay/:mandateNo"
            element={
              <V2RouteWrapper
                flag="USE_V2_MANAGE_AUTOPAY"
                V2Component={ViewMandateDetail}
                V1Component={ViewMandateDetail}
                requiredPermission={PERMISSIONS.MANAGE_AUTOPAY}
              />
            }
          />
          <Route
            path="/revoke-autopay-list"
            element={
              <V2RouteWrapper
                flag="USE_V2_MANAGE_AUTOPAY"
                V2Component={RevokeMandateList}
                V1Component={RevokeMandateList}
                requiredPermission={PERMISSIONS.MANAGE_AUTOPAY}
              />
            }
          />
          <Route
            path="/society-partner-details"
            element={
              <V2RouteWrapper
                flag="USE_V2_PARTNER"
                V2Component={SocietyPartnerDetailsGate}
                V1Component={SocietyPartnerDetailsGate}
                requiredPermission={PERMISSIONS.PARTNER_SOCIETY_PARTNER}
              />
            }
          />
          <Route
            path="/permission-management"
            element={
              <V2ToggleRoute
                flag="USE_V2_ACCESS_MANAGEMENT"
                V2Component={PermissionManagementV2}
                V1Component={PermissionManagement}
                requiredPermission={PERMISSIONS.PERMISSION_MANAGEMENT}
              />
            }
          />
          <Route
            path="/role-management"
            element={
              <V2ToggleRoute
                flag="USE_V2_ACCESS_MANAGEMENT"
                V2Component={RoleManagementV2}
                V1Component={RoleManagement}
                requiredPermission={PERMISSIONS.ROLE_MANAGEMENT}
              />
            }
          />
          <Route
            path="/role-management/:roleName"
            element={
              <V2ToggleRoute flag="USE_V2_ACCESS_MANAGEMENT" requiredPermission={PERMISSIONS.ROLE_MANAGEMENT} V2Component={RolePermissionsV2} V1Component={PermissionsPage} />
            }
          />
          <Route
            path="/banner/list"
            element={
              <V2RouteWrapper
                flag="USE_V2_MANAGE_NOTIFICATION"
                V2Component={BannerListV2}
                V1Component={SendBanner}
                requiredPermission={PERMISSIONS.SEND_NOTIFICATION}
              />
            }
          />
          <Route
            path="/maintenance/list"
            element={
              <V2RouteWrapper
                flag="USE_V2_SCHEDULE_MAINTENANCE"
                V2Component={ScheduleMaintenance}
                V1Component={ScheduleMaintenance}
                requiredPermission={PERMISSIONS.SEND_NOTIFICATION}
              />
            }
          />
          <Route
            path="/banner/update/:bannerId"
            element={
              <V2RouteWrapper
                flag="USE_V2_MANAGE_NOTIFICATION"
                V2Component={BannerFormV2}
                V1Component={Create}
                requiredPermission={PERMISSIONS.SEND_NOTIFICATION}
              />
            }
          />

          <Route
            path="/society-partner-hub"
            element={
              <V2RouteWrapper
                flag="USE_V2_ORGANIZATION_HUB"
                V2Component={SocietyPartnerHubV2}
                V1Component={SocietyPartnerHub}
                requiredPermission={PERMISSIONS.ORGANIZATION_HUB}
              />
            }
          />
          <Route
            path="/cpv-listing"
            element={
              <V2RouteWrapper
                flag="USE_V2_CPV_LISTING"
                V2Component={CpvListingV2}
                V1Component={CPVUserList}
                requiredPermission={PERMISSIONS.CPV_LISTING}
              />
            }
          />
          <Route
            path="/society-partner-hub/:societyName"
            element={
              <V2RouteWrapper
                flag="USE_V2_ORGANIZATION_HUB"
                V2Component={SocietyDashboardV2}
                V1Component={SocietyDashboard}
                requiredPermission={PERMISSIONS.ORGANIZATION_HUB}
              />
            }
          />
          <Route
            path="/card-management"
            element={
              <V2ToggleRoute
                flag="USE_V2_CARD_MANAGEMENT"
                V2Component={CardProductManagementV2}
                V1Component={CardProductManagement}
                requiredPermission={PERMISSIONS.CARD_MANAGEMENT}
              />
            }
          />
          <Route
            path="/org-card-management"
            element={
              <V2ToggleRoute
                flag="USE_V2_CARD_MANAGEMENT"
                V2Component={OrgCardManagementV2}
                V1Component={OrgCardManagement}
                requiredPermission={PERMISSIONS.ORG_CARD_MANAGEMENT}
              />
            }
          />
          <Route
            path="/inventory-management/QR-code-inventory"
            element={
              <V2ToggleRoute
                flag="USE_V2_INVENTORY_MANAGEMENT"
                V2Component={QRInventoryV2}
                V1Component={QRCodeInventory}
                requiredPermission={PERMISSIONS.QR_INVENTORY}
              />
            }
          />
          <Route
            path="/inventory-management/soundbox-inventory"
            element={
              <V2ToggleRoute
                flag="USE_V2_INVENTORY_MANAGEMENT"
                V2Component={SoundboxInventoryV2}
                V1Component={SoundboxInventory}
                requiredPermission={PERMISSIONS.SOUNDBOX_INVENTORY}
              />
            }
          />
           <Route
            path="/inventory-management/QR-request"
            element={
              <V2ToggleRoute
                flag="USE_V2_INVENTORY_MANAGEMENT"
                V2Component={QRRequestV2}
                V1Component={QRRequest}
                requiredPermission={PERMISSIONS.QR_REQUEST}
              />
            }
          />
          {/* <Route
        path="/escrow-transactions"
        element={
          <RequireAuth>
            <EscrowTransactions />
          </RequireAuth>
        }
      /> */}
          <Route path="*" element={<PageNotFound />} />
        </>
      )}
    </Routes>
  );
}

export default RouteComponent;
